export const generateTitle = (title?: string, siteName?: string): string => {
  if (!title && !siteName) return "Cinema Booking";
  if (!title) return siteName || "Cinema Booking";
  if (!siteName) return title;
  return `${siteName} | ${title}`;
};

export const formatKeywords = (keywords?: string[]): string => {
  if (!keywords || keywords.length === 0) return "";
  return keywords.join(", ");
};

export const generateStructuredData = (
  data: Record<string, any> | Record<string, any>[],
): string => {
  return JSON.stringify(data, null, 2);
};
